// extracted by mini-css-extract-plugin
export default {"container":"CmsFactBox-module__container-g9VuSg","hasBackground":"CmsFactBox-module__hasBackground-WOJef6"};